// The change card in the platform agent's panel (D5). Wording from the Amigo design's copy sheet (Card, Rejecting,
// Summary first, Row status, Applying, Done, Rejected, Replaced, Changed in the meantime, Partly failed).
export default {
  loading: 'Se încarcă modificarea…',
  load_failed: 'Nu am putut încărca această modificare.',
  load_retry: 'Încearcă din nou',
  // An approve that found the set approved already, in another tab or by the agent's follow-up (QA19).
  already_approved: 'Aceasta a fost deja aprobată, deci nu mai era nimic de făcut.',
  action_failed: 'Nu a funcționat, așa că nu s-a schimbat nimic. Încearcă din nou în scurt timp.',
  removed: 'Eliminat',
  retry: 'Încearcă din nou',
  retry_one: 'Încearcă din nou {{name}}',
  // The message the panel sends the agent with the card's outcome (contracts §5 clientContext.changeSet).
  message: {
    approved: 'Aprobat.',
    retried: 'Încercat din nou.',
    rejected: 'Respins.',
  },
  done: {
    summary_one: 'Gata. {{count}} modificare aplicată.',
    summary_few: 'Gata. {{count}} modificări aplicate.',
    summary_other: 'Gata. {{count}} de modificări aplicate.',
    skipped_one: '{{count}} omisă, nimic nu s-a schimbat pentru ea.',
    skipped_few: '{{count}} omise, nimic nu s-a schimbat pentru ele.',
    skipped_other: '{{count}} de omise, nimic nu s-a schimbat pentru ele.',
  },
  partial: {
    summary_one: '{{applied}} din {{approved}} modificări aplicate. {{count}} de modificări nu.',
    summary_few: '{{applied}} din {{approved}} modificări aplicate. {{count}} nu.',
    summary_other: '{{applied}} din {{approved}} modificări aplicate. {{count}} de modificări nu.',
    detail_one: 'Cele {{applied}} sunt salvate. Nimic nu s-a schimbat pentru cele {{count}} de mai jos.',
    detail_few: 'Cele {{applied}} sunt salvate. Nimic nu s-a schimbat pentru cele {{count}} de mai jos.',
    detail_other: 'Cele {{applied}} sunt salvate. Nimic nu s-a schimbat pentru cele {{count}} de mai jos.',
  },
  stale: {
    summary: '{{applied}} din {{approved}} modificări aplicate.',
    detail_one: '{{count}} a fost modificată de altcineva între timp.',
    detail_few: '{{count}} au fost modificate de altcineva între timp.',
    detail_other: '{{count}} de modificări au fost făcute de altcineva între timp.',
    reason:
      '{{name}} a schimbat-o în {{value}} la {{time}}, înainte să aprobi, așa că am lăsat-o neschimbată. Iat-o din nou, pornind de la noua valoare:',
  },
  undone: {
    summary_one: 'Anulat. Cele {{count}} modificare a revenit la starea de dinainte.',
    summary_few: 'Anulat. Cele {{count}} modificări au revenit la starea de dinainte.',
    summary_other: 'Anulat. Cele {{count}} de modificări au revenit la starea de dinainte.',
    detail: 'Anularea este înregistrată și în jurnalul Amigo și în Meniu → Istoric modificări.',
  },
  summary: {
    average: '{{amount}} pe fel de mâncare, în medie',
    needs_look: 'Necesită verificare',
    nothing_else: 'Nimic altceva nu se schimbă',
  },
  labels: {
    waiting: 'Se așteaptă aprobarea',
    skip: 'Omite',
    unskip: 'Anulează omiterea',
    approve_all: 'Aprobă tot',
    approve_one: 'Aprobă {{count}}',
    approve_few: 'Aprobă {{count}}',
    approve_other: 'Aprobă {{count}}',
    approve_row: 'Aprobă',
    reject: 'Respinge…',
    reject_confirm: 'Respinge',
    back: 'Înapoi',
    why: {
      amigo: 'De ce nu? (opțional, Amigo citește asta)',
      assistant: 'De ce nu? (opțional, asistentul citește asta)',
    },
    hint: 'Sau răspunde mai jos ca să schimbi ceva.',
    show_all_one: 'Arată toate cele {{count}} modificări',
    show_all_few: 'Arată toate cele {{count}} modificări',
    show_all_other: 'Arată toate cele {{count}} modificări',
    show_less: 'Arată mai puține',
    applying_one: 'Se aplică {{count}} modificare…',
    applying_few: 'Se aplică {{count}} modificări…',
    applying_other: 'Se aplică {{count}} de modificări…',
    rows: {
      skipped: 'Omis',
      applied: 'Aplicat',
      failed: 'Neaplicat',
      changed: 'Modificat între timp',
      kept: 'Lăsat neschimbat',
    },
    history: {
      amigo: 'Deschide în jurnalul Amigo',
      assistant: 'Deschide în jurnalul asistentului',
    },
    undo: 'Anulează',
    to: 'la',
    from: 'de la',
    rejected: 'Respins',
    replaced: 'Înlocuit',
    expired: 'Expirat',
  },
};
